import { create } from "zustand";
import { ProductType } from "@/types/product.type";
import { persist } from "zustand/middleware";

type Props = {
  products: (ProductType & { viewedAt: number })[];
  setProduct: (product: ProductType) => void;
};

const EXPIRATION_TIME = 7 * 24 * 60 * 60 * 1000;
const MAX_PRODUCTS = 20;

const useRecentlyViewedProducts = create<Props>()(
  persist(
    (set) => ({
      products: [],
      setProduct: (product) => {
        const now = Date.now();

        set((state) => {
          let validProducts = state.products.filter(
            (p) => now - p.viewedAt < EXPIRATION_TIME,
          );

          const exists = validProducts.some((p) => p.id === product.id);
          if (exists) return { products: validProducts };

          validProducts.push({ ...product, viewedAt: now });

          if (validProducts.length > MAX_PRODUCTS) {
            validProducts = validProducts.slice(-MAX_PRODUCTS);
          }

          return { products: validProducts };
        });
      },
    }),
    {
      name: "recently-viewed-products",
      onRehydrateStorage: () => (state) => {
        if (state) {
          const now = Date.now();
          state.products = state.products
            .filter((p) => now - p.viewedAt < EXPIRATION_TIME)
            .slice(-MAX_PRODUCTS);
        }
      },
    },
  ),
);

export default useRecentlyViewedProducts;
